/**
 * @file Mixin to work with visual viewport size for root vue app
 */
import { browserCan } from 'bits/browser'
import window from 'bits/global'
import { observeVisualViewportSize } from 'bits/window'
import debounce from 'lodash.debounce'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const browser = namespace('browser')

@Component
export default class VisualViewportSizeMixin extends Vue {
  unobserveVisualViewportSize: (() => void) | null = null
  @browser.Action resizeVisualViewport!: ({
    height,
    width,
    scale,
  }: {
    height: number
    width: number
    scale: number
  }) => void

  mounted(): void {
    if (browserCan('visualViewport')) {
      this.resizeVisualViewport({
        height: window.visualViewport.height,
        width: window.visualViewport.width,
        scale: window.visualViewport.scale,
      })
      this.unobserveVisualViewportSize = observeVisualViewportSize(debounce(this.resizeVisualViewport, 250))
    }
  }

  beforeDestroy(): void {
    this.unobserveVisualViewportSize && this.unobserveVisualViewportSize()
  }
}
